.root {
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  background: var(--rec-color-background);
  border: 1px solid var(--rec-color-border);
  border-radius: 10px;
}

.severity-bar {
  flex: 0 0 3px;
  border-radius: 2px;
  background: var(--rec-color-warning-dot);
}

.root-severity-suggestion .severity-bar {
  background: var(--rec-color-border-strong);
}

.body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.badge {
  flex: none;
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--rec-color-warning);
  color: var(--rec-color-warning-fg);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.root-severity-suggestion .badge {
  background: var(--rec-color-neutral-chip);
  color: var(--rec-color-muted-fg);
}

.title {
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--rec-color-btn-dark);
}

.cat-pill {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 100px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.cat-pill-category-brief {
  background: var(--rec-color-orange-bg);
  color: var(--rec-color-orange-fg);
}

.cat-pill-category-dining {
  background: var(--rec-color-pink-bg);
  color: var(--rec-color-pink-fg, #9d174d);
}

.cat-pill-category-accommodation {
  background: var(--rec-color-purple-bg);
  color: var(--rec-color-purple-fg);
}

.cat-pill-category-activities {
  background: var(--rec-color-orange-bg);
  color: var(--rec-color-orange-fg);
}

.cat-pill-category-transportation {
  background: var(--rec-color-sky-bg);
  color: var(--rec-color-sky-fg);
}

.desc {
  margin: 0;
  font-size: 10px;
  line-height: 1.4;
  color: var(--rec-color-muted);
}

.actions {
  display: flex;
  gap: 6px;
}

.action {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid var(--rec-color-border);
  background: var(--rec-color-header-bg);
  color: #334155;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: var(--rec-color-neutral-chip);
  }
}

// Small × in the card header. Subtle by default; opacity ramps up on
// card hover so the affordance is discoverable without competing with
// the primary Ask-client button.
.dismiss {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-left: 2px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--rec-color-muted);
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.55;
  transition: opacity 0.12s ease, background-color 0.12s ease;

  &:hover {
    opacity: 1;
    background: var(--rec-color-neutral-chip);
  }
}

.root:hover .dismiss {
  opacity: 0.85;
}
